module.exports = __webpack_public_path__ + "media/images/webpage/coupons/howto-selected-aeecb3c0a7900a7a3c0f8a06392060b9.webp";